export default {
    computed: {
        isDevelopment() {
            return process.env.VUE_APP_DEV === 'true';
        },
        devMode() {
            return process.env.VUE_APP_DEV;
        },
        apiEndpoint() {
            return process.env.VUE_APP_API_ENDPOINT;
        }
    }
}
